import { useMutation, useQuery, useQueryClient } from "react-query";

import axios from "axios";
import { nuclearn_api_url } from "src/App";

const getBucket = (bucketId) => {
  return axios
    .get(`${nuclearn_api_url}/stats/bucket/${bucketId}`)
    .then((response) => {
      return response.data;
    });
};

export const useGetBucket = (bucketId) => {
  return useQuery(["bucket", bucketId], () => getBucket(bucketId), {
    refetchOnWindowFocus: false,
    enabled: !!bucketId,
  });
};

const getBucketList = ({ analyticId, details }) => {
  var params = new URLSearchParams();
  if (analyticId) {
    params.append("analytic_id", analyticId);
  }
  if (details) {
    params.append("details", details);
  }
  return axios
    .get(`${nuclearn_api_url}/stats/bucket?${params.toString()}`)
    .then((response) => {
      return response.data.sort((a, b) => {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });
    });
};

export const useBucketList = (queryParams) => {
  return useQuery(
    ["bucketList", queryParams],
    () => getBucketList(queryParams),
    {
      refetchOnWindowFocus: false,
      enabled: !!queryParams,
    },
  );
};

const createBucket = (bucketInfo) => {
  return axios
    .put(nuclearn_api_url + "/stats/bucket", bucketInfo)
    .then((response) => {
      return response.data;
    });
};

export const useCreateBucket = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(createBucket, {
    onSuccess: () => {
      queryClient.invalidateQueries("bucket");
      queryClient.invalidateQueries("bucketList");
    },
    onError: (error) => {
      console.log(error.response);
    },
  });
  return mutation;
};

const updateBucket = ({ bucketId, bucket }) => {
  return axios
    .patch(`${nuclearn_api_url}/stats/bucket/${bucketId}`, bucket)
    .then((response) => {
      return response.data;
    });
};

export const useUpdateBucket = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(updateBucket, {
    onSuccess: () => {
      queryClient.invalidateQueries("bucketList");
      queryClient.invalidateQueries("bucket");
    },
    onError: (error) => {
      console.log(error.response);
    },
  });
  return mutation;
};

const deleteBucket = (bucketId) => {
  return axios
    .delete(`${nuclearn_api_url}/stats/bucket/${bucketId}`)
    .then(() => {
      return bucketId;
    });
};

export const useDeleteBucket = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(deleteBucket, {
    onSuccess: (_, vars) => {
      queryClient.invalidateQueries("bucketList");
      queryClient.invalidateQueries(["bucket", vars]);
    },
    onError: (error) => {
      console.log(error.response);
    },
  });
  return mutation;
};
